import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import ls from 'local-storage';
import { useState } from 'react';
import { useEffect } from 'react';
import ManageAccountLinks from "../../Component/ManageAccountLinks/ManageAccountLinks"
import API from "../../Services/BaseService";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import StateAndCity from '../../Component/StateAndCity/StateAndCity'
import { useForm } from "react-hook-form";
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import StateAndCitySearch from '../../Component/StateAndCity/StateAndCitySearch';
import PageNotFound from '../FallBackUI/PageNotFound';

const Payment = (props) => {
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm();
    const { flagFilter, selectSellerId } = props.location.state;
    console.log(props.location.state, "payment======");
    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("")

    const [Type, setType] = useState("");
    const [buyerId, setBuyerId] = useState("");
    const [dealershipName, setDealershipName] = useState("");
    const [accountHolderName, setAccountHolderName] = useState("");
    const [bankName, setBankName] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [ACHnumber, setACHNumber] = useState("");
    const [routingNumber, setRoutingNumber] = useState("");
    const [bankAddress, setBankAddress] = useState("");
    const [cityName, setCityName] = useState("");
    const [stateName, setStateName] = useState("");
    const [zipCodeId, setZipcodeId] = useState("");
    const [accountHolderAddress, setAccountHolderAddress] = useState("");
    const [accountCityName, setAccountCityName] = useState("");
    const [accountStateName, setAccountStateName] = useState("");
    const [accountZipcodeId, setAccountZipcodeId] = useState("");
    const [defaultStatus, setDefaltStatus] = useState("No");
    console.log("accountHolderAddress", accountHolderAddress);
    const [doc, setDoc] = useState("");
    const [dealershipNameError, setDealershipNameError] = useState("");
    const [accountHolderNameError, setAccountHolderNameError] = useState("");
    const [bankNameError, setBankNameError] = useState("");
    const [accountNumberError, setAccountNumberError] = useState("");
    const [ACHnumberError, setACHNumberError] = useState("");
    const [routingNumberError, setRoutingNumberError] = useState("");
    const [bankAddressError, setBankAddressError] = useState("");
    const [accountHolderAddressError, setAccountHolderAddressError] = useState("");
    const [docError, setDocError] = useState("");
    const [state, setState] = useState("1");
    const [city, setCity] = useState("1");
    const [zipcodeId, setZipCodeId] = useState("1");
    const [zipCode, setZipCode] = useState("1");
    const [stateAndCityError, setStateAndCityError] = useState("");
    const [accStateAndCityError, setAccStateAndCityError] = useState("");
    const [stateCityFlag, setStateCityFlag] = useState("");
    const [accstateCityFlag, setAccStateCityFlag] = useState("");

    const [paymentErrors, setPaymentErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    const [changesArray, setChangesArray] = useState([]);

    const successData = useSelector(state => state.LoginReducer.payload);

    const dealerData = useSelector(state => state.DealerReducer.payload);
    let files = [];
    let userDetails = ls.get('userDetails');

    const setZipcode = (data, con) => {
        console.log("con=>", con)
        if (data.length != 5) {
            if (con === 1) {
                setCityName('')
                setStateName('')
                // setZipcodeId(data)
            }
            else {
                setAccountCityName('')
                setAccountStateName('')
                // setAccountZipcodeId(data)
            }
        }
        if (data.length == 5) {
            if (con === 1) {
                setZipcodeId(data)
            }
            else {
                setAccountZipcodeId(data)
            }
            const request = {
                zipcode_id: data, seller_id: successData.seller_id,
                seller_token: successData.seller_token,
            }

            API.post("seller_payment_info/condition", request)
                .then(response => {
                    if (response.data.success === true) {
                        if (response.statusText == "OK") {
                            console.log("google place data =>", data)
                            const { results } = response.data.data
                            if (results.length > 0) {

                                console.log("CITY  ", results[0].address_components[1].long_name)
                                console.log("STATE  ", results[0].address_components[2].long_name)
                                if (con === 1) {
                                    setCityName(results[0].address_components[1].long_name)
                                    setStateName(results[0].address_components[3].long_name)
                                }
                                else {
                                    setAccountCityName(results[0].address_components[1].long_name)
                                    setAccountStateName(results[0].address_components[3].long_name)
                                }
                            }
                            else {
                                setCityName('')
                                setStateName('')
                                setAccountCityName('')
                                setAccountStateName('')
                                console.log("please enter valid zipcode");
                            }
                        } else {
                            console.log("something went wrong in address api..., try again")
                        }
                    }
                    else {
                        setPaymentErrors(response.data.error)
                        setErrorFlag(true)
                    }

                })
                .catch(function (error) {
                    if (error.response) {
                        setPaymentErrors(error.response.data.error)
                        setErrorFlag(true)
                    }
                });
        }

    }
    const onFileChange = (event) => {
        setDoc(event.target.files[0]);
    };
    const isValidFile = (file) => {
        const extension = file.name.split(".").pop().toLowerCase();

        return [
            "txt",
            "doc",
            "docx",
            "pdf",
            "png",
            "jpg",
            "jpeg"
        ].includes(extension);
    };
    const paymenthandleSubmit = (data) => {
        // setOpenLoader(true);
        // event.preventDefault();    

        setDealershipNameError("")
        setAccountHolderNameError("")
        setBankNameError("")
        setAccountNumberError("")
        setACHNumberError("")
        setRoutingNumberError("")
        setBankAddressError("")
        setStateAndCityError("")
        setAccountHolderAddressError("")
        setAccStateAndCityError("")
        setDocError("")

        console.log("=====docdoc====>", doc)

        if (!dealershipName) {
            setDealershipNameError("Dealership Name is required")
            return;
        }
        else if (dealershipName.length > 50) {
            setDealershipNameError("Dealership Name must not exceed 50 characters")
            return;
        }
        if (!accountHolderName) {
            setAccountHolderNameError("Signer on account is required")
            return;
        }
        else if (accountHolderName.length > 50) {
            setAccountHolderNameError("Signer on account must not exceed 50 characters")
            return;
        }
        if (!bankName) {
            setBankNameError("Bank Name is required")
            return;
        }
        else if (bankName.length > 50) {
            setBankNameError("Bank Name must not exceed 50 characters")
            return;
        }

        if (!accountNumber) {
            setAccountNumberError("Account Number is required")
            return;
        }
        else if (accountNumber.length > 50) {
            setAccountNumberError("Account Number must not exceed 50 digits ")
            return;
        }
        if (!ACHnumber) {
            setACHNumberError("ACH Number is required")
            return;
        }
        else if (ACHnumber.length > 50) {
            setACHNumberError("ACH Number must not exceed 50 digits")
            return;
        }
        if (!routingNumber) {
            setRoutingNumberError("Routing Number is required")
            return;
        }
        else if (routingNumber.length > 50) {
            setRoutingNumberError("Routing Number must not exceed 50 digits")
            return;
        }
        if (!bankAddress) {
            setBankAddressError("Bank Address is required")
            return;
        }
        else if (bankAddress.length > 150) {
            setBankAddressError("Bank Address must not exceed 150 characters")
            return;
        }
        if (!stateName) {
            setStateAndCityError("1")
            return
        }
        if (!cityName) {
            setStateAndCityError("2")
            return
        }
        if (!zipCodeId) {
            setStateAndCityError("3")
            return
        }
        if (!accountHolderAddress) {
            setAccountHolderAddressError("AccountHolder Address is required")
            return;
        }
        else if (accountHolderAddress.length > 150) {
            setAccountHolderAddressError("AccountHolder Address must not exceed 150 characters")
            return;
        }
        if (!accountStateName) {
            setAccStateAndCityError("1")
            return
        }
        if (!accountCityName) {
            setAccStateAndCityError("2")
            return
        }
        if (!accountZipcodeId) {
            setAccStateAndCityError("3")
            return
        }
        // if(!doc){
        //     setDocError("Upload Document is required")
        //     return;
        // }

        if (!doc) {
            setType("1");
            return;
        }
        else if (!isValidFile(doc)) {
            setType("2");
            return;
        }
        else {
            //     setType("");
            // }
            // else if(doc[0].type.includes('.txt') || doc[0].type.includes('.doc') || doc[0].type.includes('.pdf') || doc[0].type.includes('.png') || doc[0].type.includes('.jpeg') || doc[0].type.includes('.jpg'))
            // {
            //     setType("2");
            // }



            // if( Type!=="1" ){
            console.log("type", Type);

            let request = {
                // seller_dealer_id: flagFilter == true ? selectSellerId : successData.seller_dealer_id,
                seller_dealer_id: dealerData === "null" || dealerData === null ? successData.seller_dealer_id : dealerData?.seller_dealer_id,
                seller_id: successData.seller_id,
                seller_token: successData.seller_token,
                dealership_name: dealershipName,
                acc_name: accountHolderName,
                bank_name: bankName,
                acc_no: accountNumber,
                ach_no: ACHnumber,
                routing_no: routingNumber,
                bank_address: bankAddress,
                acc_address: accountHolderAddress,

                historylist: changesArray,
                state_id: stateCityFlag === "" ? stateName : "",
                city_id: stateCityFlag === "" ? cityName : "",
                zipcode_id: stateCityFlag === "" ? zipCodeId : "",
                state_name: stateCityFlag !== "" ? stateName : "",
                city_name: stateCityFlag !== "" ? cityName : "",
                zipcode: stateCityFlag !== "" ? zipCodeId : "",

                acc_state_id: accstateCityFlag === "" ? accountStateName : "",
                acc_city_id: accstateCityFlag === "" ? accountCityName : "",
                acc_zipcodeid: accstateCityFlag === "" ? accountZipcodeId : "",
                acc_state_name: accstateCityFlag !== "" ? accountStateName : "",
                acc_city_name: accstateCityFlag !== "" ? accountCityName : "",
                acc_zipcode: accstateCityFlag !== "" ? accountZipcodeId : "",

                doc_name: doc ? [doc] : [],
                default_status: defaultStatus,
                active: 1
            }
            console.log("payment Req", request);
            // return
            API
                .post("seller_payment_info/add", request)
                .then((response) => {
                    if (response.data.success) {
                        const { data } = response;
                        console.log("response", response)
                        togglePopup()
                        setPopupTitle("Create Payment");
                        setPopupMsg("Payment Successfully Created");
                        setPopupType("success");
                        setPopupActionType("redirect");
                        setPopupActionValue("ok");
                        setPopupActionPath("/paymentinfo")
                    } else {
                        togglePopup()
                        setPopupTitle("Create Payment");
                        // setPopupMsg("Payment is not Created, Please try Again");
                        setPopupMsg(response.data.error.err);
                        setPopupType("error");
                        setPopupActionType("close");
                        setPopupActionValue("close");
                    }
                }, (error) => {
                    // setOpenLoader(false);
                    togglePopup()
                    setPopupTitle("Error");
                    setPopupMsg("Something went wrong, Please try Again");
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                })
                .catch(function (error) {
                    if (error.response) {
                        setPaymentErrors(error.response.data.error)
                        setErrorFlag(true)
                    }
                });
        }

    }
    // const getFiles=(file)=>{
    //     const newValue = e.target.value;
    //     setDoc(file);
    //     setType("");
    //     const existingChangeIndex = changesArray.findIndex(change => change.name === 'Instruction');
    //     if (existingChangeIndex !== -1) {
    //         const updatedChangesArray = [...changesArray];
    //         updatedChangesArray[existingChangeIndex] = { newvalue: "Instruction Added As "+ newValue  , name: 'Instruction' };
    //         setChangesArray(updatedChangesArray);
    //     } else {
    //         const change = { newvalue:"Instruction Added As "+ newValue, name: 'Instruction' };
    //         setChangesArray([...changesArray, change]);
    //     }
    //   }
    const getFiles = async (event) => {
        const selectedFile = event.target.files[0];

        if (!selectedFile) return;

        const file = await convertToBase64(selectedFile);

        setDoc(file);
        setType("");

        const existingChangeIndex = changesArray.findIndex(
            change => change.name === "Document"
        );

        if (existingChangeIndex !== -1) {
            const updated = [...changesArray];
            updated[existingChangeIndex] = {
                newvalue: file.name,
                name: "Document"
            };
            setChangesArray(updated);
        } else {
            setChangesArray([
                ...changesArray,
                {
                    newvalue: file.name,
                    name: "Document"
                }
            ]);
        }
    };

    const getStateName = (stateData, flag, type) => {
        setStateName(stateData)
        setStateCityFlag(flag)
        if (flag === "") {
            setCityName(null)
            setZipcodeId(null)
        }
        const newValue = stateData;
        const oldvalue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: type };
                return updatedChangesArray;
            } else {
                const change = { newvalue: newValue, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getCityName = (cityData, flag, type) => {
        setCityName(cityData)
        if (flag === "") {
            setZipcodeId(null)
        }
        const newValue = cityData;
        const oldvalue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: type };
                return updatedChangesArray;
            } else {
                const change = { newvalue: newValue, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getZipCodeId = (zipData, type, flag) => {
        setZipcodeId(zipData)
        const newValue = zipData;
        const oldvalue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: type, flag: "dropdown" };
                return updatedChangesArray;
            } else {
                const change = { newvalue: newValue, name: type, flag: "dropdown" };
                return [...prevChangesArray, change];
            }
        });
    }

    const getError = (data, flag) => {
        console.log("reg flag", data, flag);
        setPaymentErrors(data)
        setErrorFlag(flag)
    }

    const getAccStateName = (stateData, accflag, type) => {
        setAccountStateName(stateData)
        setAccStateCityFlag(accflag)
        if (accflag === "") {
            setAccountCityName(null)
            setAccountZipcodeId(null)
        }
        const newValue = stateData;
        const oldvalue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                // updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: `${type} has been added as ${newValue}`, name: type };
                updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: type };
                return updatedChangesArray;
            } else {
                const change = { newvalue: newValue, name: type };
                return [...prevChangesArray, change];
            }
        });

    }

    const getAccCityName = (cityData, accflag, type) => {
        setAccountCityName(cityData)
        if (accflag === "") {
            setAccountZipcodeId(null)
        }
        const newValue = cityData;
        const oldvalue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: type };
                return updatedChangesArray;
            } else {
                const change = { newvalue: newValue, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getAccZipCodeId = (zipData, type, flag) => {
        setAccountZipcodeId(zipData)
        const newValue = zipData;
        const oldvalue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: type, flag: "dropdown" };
                return updatedChangesArray;
            } else {
                const change = { newvalue: newValue, name: type, flag: "dropdown" };
                return [...prevChangesArray, change];
            }
        });
    }
    const handleDealershipnameChange = (e) => {
        const newValue = e.target.value;
        setDealershipName(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Dealership Name');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: 'Dealership Name' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: newValue, name: 'Dealership Name' };
            setChangesArray([...changesArray, change]);
        }
    }
    const handleAccountHoldernameChange = (e) => {
        const newValue = e.target.value;
        setAccountHolderName(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Signer on Account');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: 'Signer on Account' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: newValue, name: 'Signer on Account' };
            setChangesArray([...changesArray, change]);
        }
    }
    const handleBankNameChange = (e) => {
        const newValue = e.target.value;
        setBankName(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Bank Name');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: 'Bank Name' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: newValue, name: 'Bank Name' };
            setChangesArray([...changesArray, change]);
        }
    }
    const handleAccountNumberChanges = (e) => {
        const newValue = e.target.value;
        setAccountNumber(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Account Number');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: 'Account Number' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: newValue, name: 'Account Number' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleACHNumberChange = (e) => {
        const newValue = e.target.value;

        setACHNumber(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'ACH Number');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: 'ACH Number' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: newValue, name: 'ACH Number' };
            setChangesArray([...changesArray, change]);
        }
    }
    const handleRoutingNumberChange = (e) => {
        const newValue = e.target.value;
        setRoutingNumber(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Routing Number');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: 'Routing Number' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: newValue, name: 'Routing Number' };
            setChangesArray([...changesArray, change]);
        }
    }
    const handleBankAddressChange = (e) => {
        const newValue = e.target.value;
        setBankAddress(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Bank Address');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: 'Bank Address' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: newValue, name: 'Bank Address' };
            setChangesArray([...changesArray, change]);
        }
    }
    const handleAccountHolderAddressChange = (e) => {
        const newValue = e.target.value;
        setAccountHolderAddress(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Account Holder Address');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: newValue, name: 'Account Holder Address' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: newValue, name: 'Account Holder Address' };
            setChangesArray([...changesArray, change]);
        }
    }
    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => {
                resolve({
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    base64: reader.result
                });
            };

            reader.onerror = (error) => reject(error);
        });
    };

    return (
        <div>

            <main id="main" className="inner-page">
                {errorFlag === true ? <PageNotFound error={paymentErrors} /> :

                    <div id="paymentaccount" className="paymentaccount">
                        <div className="container-fluid inner-page-space" >
                            <div class="common-heading">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div class="back-btn">
                                            <button className="back-btn-paymentform backBtn" onClick={() => history.push("/paymentinfo")}><i class="icofont-arrow-left"></i> Back</button>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div class="title">
                                            <p class="inner-title">Create Financials</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                    </div>
                                </div>
                            </div>
                            <div className="paymentaccountblock">
                                <div className="row content">
                                    <div className="col-lg-4 col-md-12 col-sm-12 accountleftblock">
                                        <ManageAccountLinks />
                                    </div>
                                    <div className="col-lg-8 col-md-12 col-sm-12 paymentrightblock">
                                        <div className="paymentdetailblock">
                                            <p>Thank you for providing us the information of your bank Account. We are going to use this for making charges to your account whenever you purchase a car to assure easy transaction for your business</p>
                                            <div className="paymentform card col-lg-12">
                                                <form className="backaccountform addpaymentform" onSubmit={handleSubmit(paymenthandleSubmit)}>
                                                    <h2 className="title"> Bank account information</h2>
                                                    <div className="row">
                                                        <div className="col-sm-12 form-group topforms">
                                                            <div className="tbox">
                                                                <input type="text" className="textbox" name="dealershipName" id="name-d" placeholder=""
                                                            /* onChange={(e) => setDealershipName(e.target.value)} */ onChange={handleDealershipnameChange} />
                                                                <label htmlFor="name-d" className={dealershipName != "" ? "input-has-value required" : "required"}>Dealership Name</label>
                                                                <p className="form-input-error" >{dealershipNameError}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" className="textbox" name="accountHolderName" id="name-f" placeholder=""
                                                                    onChange={handleAccountHoldernameChange} />
                                                                <label htmlFor="name-f" className={accountHolderName != "" ? "input-has-value required" : "required"}>Signer on Account</label>
                                                                <p className="form-input-error" >{accountHolderNameError}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" className="textbox" name="bankName" id="name-b" placeholder=""
                                                            /* onChange={(e) => setBankName(e.target.value)} */ onChange={handleBankNameChange} />
                                                                <label htmlFor="name-b" className={bankName != "" ? "input-has-value required" : "required"}>Bank Name</label>
                                                                <p className="form-input-error" >{bankNameError}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" className="textbox" name="accountNumber" id="anumber" placeholder=""
                                                           /*  onChange={(e) => setAccountNumber(e.target.value)} */ onChange={handleAccountNumberChanges} />
                                                                <label htmlFor="anumber" className={accountNumber != "" ? "input-has-value required" : "required"}>Account Number</label>
                                                                <p className="form-input-error" >{accountNumberError}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" className="textbox" name="ACHnumber" id="achnumber" placeholder=""
                                                            /* onChange={(e) => setACHNumber(e.target.value)} */ onChange={handleACHNumberChange} />
                                                                <label htmlFor="achnumber" className={ACHnumber != "" ? "input-has-value required" : "required"}>ACH Number</label>
                                                                <p className="form-input-error" >{ACHnumberError}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" className="textbox" name="routingNumber" id="rtnumber" placeholder=""
                                                            /* onChange={(e) => setRoutingNumber(e.target.value)} */ onChange={handleRoutingNumberChange} />
                                                                <label htmlFor="rtnumber" className={routingNumber != "" ? "input-has-value required" : "required"}>Routing Number</label>
                                                                <p className="form-input-error" >{routingNumberError}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" className="textbox" name="bankAddress" id="baddress" placeholder=""
                                                            /* onChange={(e) => setBankAddress(e.target.value)} */ onChange={handleBankAddressChange} />
                                                                <label htmlFor="baddress" className={bankAddress != "" ? "input-has-value required" : "required"}>Bank Address</label>
                                                                <p className="form-input-error" >{bankAddressError}</p>
                                                            </div>
                                                        </div>
                                                        <StateAndCitySearch
                                                            // setStateValue = { getStateName } 
                                                            // setCityValue ={ getCityName }
                                                            // setZipcodeValue ={ getZipCodeId }
                                                            setStateValue={(stateData, flag) => getStateName(stateData, flag, "state")}
                                                            setCityValue={(cityData, flag) => getCityName(cityData, flag, "city")}
                                                            setZipcodeValue={(zipData) => getZipCodeId(zipData, "zipcode")}
                                                            setNewError={getError}
                                                            stateCityValidation={stateAndCityError}
                                                            setRequired="true"

                                                        />
                                                        {/* <div className="col-sm-12 form-group">
                                                    <p className="form-input-error1"> {stateAndCityError}</p>
                                                    </div> */}

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" className="textbox" name="accountHolderAddress" id="ahaddress" placeholder="" value={accountHolderAddress}
                                                            /* onChange={(e) => setAccountHolderAddress(e.target.value)} */ onChange={handleAccountHolderAddressChange} />
                                                                <label htmlFor="ahaddress" className={accountHolderAddress != "" ? "input-has-value required" : "required"}>Account Holder Address</label>
                                                                <p className="form-input-error" >{accountHolderAddressError}</p>
                                                            </div>
                                                        </div>

                                                        <StateAndCitySearch
                                                            // setStateValue = { getAccStateName } 
                                                            // setCityValue ={ getAccCityName }
                                                            // setZipcodeValue ={ getAccZipCodeId }
                                                            setStateValue={(stateData, flag) => getAccStateName(stateData, flag, "Signer state")}
                                                            setCityValue={(cityData, flag) => getAccCityName(cityData, flag, "Signer city")}
                                                            setZipcodeValue={(zipData) => getAccZipCodeId(zipData, "Signer zipcode")}
                                                            setNewError={getError}
                                                            stateCityValidation={accStateAndCityError}
                                                            setRequired="true"


                                                        />
                                                        {/* <div className="col-sm-12 form-group">
                                                    <p className="form-input-error1"> {accStateAndCityError}</p>
                                                    </div> */}
                                                        <div className="col-sm-12">
                                                            <div class="custom-control custom-switch toggle-switch">
                                                                <input type="checkbox" class="custom-control-input" id="customSwitch1" value={defaultStatus == "No" ? "Yes" : "No"} onClick={(e) => setDefaltStatus(e.target.value)} />
                                                                <label class="custom-control-label" for="customSwitch1">Default Bank Account</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-6 form-group required">
                                                            Signed bank Authorization letter for bank to release information.
                                                        </div>
                                                        <div className="col-sm-6 form-group uploadbtn">
                                                            <div className="upload-btn-wrapper">
                                                                {/* <button className="btn"><i className="icofont-upload-alt"></i> Upload Document</button> */}
                                                                <input
                                                                    type="file"
                                                                    accept=".txt,.doc,.docx,.pdf,.png,.jpg,.jpeg"
                                                                    onChange={getFiles}
                                                                    style={{ display: "none" }}
                                                                    id="uploadDocument"
                                                                />

                                                                <label htmlFor="uploadDocument" className="btn">
                                                                    <i className="icofont-upload-alt"></i> Upload Document
                                                                </label>
                                                            </div>
                                                            <span className="uploadedFile">
                                                                {doc?.name || ""}
                                                            </span>
                                                            {/* <p className="form-input-error" >{docError}</p> */}
                                                            {/* {type==="0"?<p className="form-input-error">Upload only Image Format </p>:""}  */}
                                                            {Type === "1" ? <p className="form-input-error">File Upload Mandatory </p> : Type === "2" ? <p className="form-input-error">Only TXT,DOC/DOCX,PDF,JPG,PNG,JPEG file formats can be uploaded</p> : ""}
                                                        </div>

                                                        <div className="col-lg-12 loginBtn">
                                                            <button className="cta-btn">Submit</button>
                                                        </div>
                                                    </div>
                                                </form>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}









                <section id="playstoreBlock" className="playstoreBlock">
                    <div className="container">


                        <div className="row content">
                            <div className="col-lg-12">
                                <img src={appstore} />
                                <img src={googleplay} />
                            </div>

                        </div>

                    </div>
                </section>

                {isOpen &&
                    <CommonPopup
                        handleClose={togglePopup}
                        popupTitle={popupTitle}
                        popupMsg={popupMsg}
                        popupType={popupType}
                        popupActionType={popupActionType}
                        popupActionValue={popupActionValue}
                        popupActionPath={popupActionPath}
                    />}



            </main>


        </div>


    );
};

export default Payment;